import { Routes, Route } from 'react-router-dom';
import Home from './components/home/listing';
import PropertyNew from './components/home/listing-new';
import PropertyNew1 from './components/home/listing-new1';
import PropertyNew11 from './components/home/listing-new11';
import PropertyDetails from './components/property/details';
import PropertyDetailsNew from './components/property/details-new';
import Header from "../src/components/home/header";
import Footer from "../src/components/home/footer";
import Story from "../src/components/home/story";
import BuyProperties from "../src/components/property/saleProperties";
import RentProperties from "../src/components/property/rentProperties";
import LikeProperties from "../src/components/property/likeProperties";
import SavedProperties from "../src/components/property/savedProperties";
import Agent from './components/agents/index';
import Developer from './components/developer/index';
import Brokers from './components/brokers/index';
import BrokerDetails from './components/brokers/details';
import Brokerage from './components/brokerage/index';
import Business from './components/business/index';
import Projects from './components/property/projectProperties';
import PreLaunch from './components/property/prelaunchProperties';
import TrendingProperties from './components/property/trendingProperties';
import NewProperties from './components/property/newProperties';
import PrivacyPolicy from "../src/components/pages/privacyPolicy";
import TermServices from "../src/components/pages/termServices";
import Chat from "../src/components/chat/chat";
import Slider from "../src/components/property/slider";
import PropertyFiles from "../src/components/property/propertyFiles";
import { useState,useEffect } from 'react';
import axios from "axios";

const App = () => {
   const[loading, setLoading] =useState(false);
   useEffect(() => {
   axios.interceptors.request.use(function (config) {
      setLoading(true);
      return config;
   }, function (error) {
      return Promise.reject(error);
   });
   
   // Add a response interceptor
   axios.interceptors.response.use(function (response) {
      setLoading(false);
      return response;
      }, function (error) {
      return Promise.reject(error);
   });
},[]);

   return (
      <>
      <Header />
      <Routes>
         <Route path="/" element={<Home />} />
         <Route path="/property/:id" element={<PropertyDetails />} />
         <Route path="/list-new" element={<PropertyNew />} />
         <Route path="/list-new1" element={<PropertyNew11 />} />
         <Route path="/list-new11" element={<PropertyNew11 />} />
         <Route path="/property-new" element={<PropertyDetailsNew />} />
         <Route path="/story" element={<Story />} />
         <Route path="/buy-properties" element={<BuyProperties />} />
         <Route path="/rent-properties" element={<RentProperties />} />
         <Route path="/like-properties" element={<LikeProperties />} />
         <Route path="/saved-properties" element={<SavedProperties />} />
         <Route path="/agents" element={<Agent />} />
         <Route path="/developers" element={<Developer />} />
         <Route path="/brokerage" element={<Brokerage />} />
         <Route path="/business" element={<Business />} />
         <Route path="/brokers" element={<Brokers />} />
         <Route path="/broker/details" element={<BrokerDetails />} />
         <Route path="/projects" element={<Projects />} />
         <Route path="/pre-launch" element={<PreLaunch />} />
         <Route path="/trending-properties" element={<TrendingProperties />} />
         <Route path="/new-properties" element={<NewProperties />} />
         <Route path="/privacy-policy" element={<PrivacyPolicy />} />
         <Route path="/term-services" element={<TermServices />} />
         <Route path="/chat" element={<Chat />} />
         <Route path="/property/images/:id" element={<Slider />} />
         <Route path="/property/files" element={<PropertyFiles />} />
      </Routes>
      <Footer />
      </>
   );
};

export default App;
 
